import React from "react";
import "../styles/Services.css";

// Helper: import all images dynamically
function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const serviceImages = importAll(
  require.context("../assets", false, /\.(png|jpe?g|webp|svg)$/)
);

const Services = () => {
  const subsections = [
    {
      title: "Certified Translations",
      text: `Professional Translation Services – Speak to the World. Expand your reach
with accurate, culturally appropriate translation services in 100+ languages.
We specialize in business, legal, medical, technical, marketing, and literary
translations, ensuring every word reflects your intent and resonates with your
audience. Our expert linguists are native speakers and industry specialists,
delivering precise, timely, and confidential translations. From documents and
websites to multimedia content, we help you communicate clearly across borders.

Quality you can trust. Dead-lines you can count on.
Get a free quote today and connect globally with confidence.

Your message. Every language. Perfectly translated.`,
      img: "c.png",
      reverse: false,
      special: true,
    },
    {
      title: "Website & App Localization",
      text: `Go Global with Confidence — Localize Your Website & App Today!
At PTS, we turn your digital platforms into powerful global tools through expert Website and App Localization. Our team adapts your content, design, and functionality to fit the language and cultural nuances of your target markets — ensuring a seamless user experience across regions. From UX-friendly translations to culturally relevant design tweaks, we help you connect with users worldwide and boost engagement. Whether launching in one new country or many, we make your digital presence truly international.

Local feel. Global impact.
Start your localization journey with us today!
Get a Free Quote`,
      img: "l.webp",
      reverse: true,
      special: true,
    },
    {
      title: "Interpretation Services",
      text: `Professional Interpretation Services – Bridge the Language Gap
Ensure clear, accurate communication with our expert interpretation services. We offer simultaneous, consecutive, and remote interpretation for business meetings, conferences, legal proceedings, healthcare appointments, and more. Our certified interpreters are fluent in 100+ languages, culturally aware, and trained to deliver precise, real-time language support. Whether in person or online, we help you connect confidently with clients, partners, and communities around the world.

Reliable. Confidential. On Demand.
Let your message be understood—everywhere. Contact us today to book a professional interpreter or request a custom quote.
Get a Free Quote`,
      img: "i.jpg",
      reverse: false,
      special: true,
    },
    {
      title: "Multimedia Subtitling & Voiceover",
      text: `Bring Your Content to Life — Globally!
At PTS, we specialize in professional Multimedia Subtitling and Voiceover Services that break language barriers and expand your reach. Whether it’s films, e-learning modules, corporate videos, or promotional content, we deliver culturally accurate subtitles and engaging voiceovers in multiple languages. Our expert linguists and voice talents ensure your message is not just translated, but truly understood. Fast turnaround, crystal-clear audio, and seamless synchronization — all tailored to your brand.

Reach new audiences. Tell your story worldwide.
Contact us today for a custom quote!
Get a Free Quote`,
      img: "m.webp",
      reverse: true,
      special: true,
    },
    {
      title: "Proofreading, Editing, and Subtitling",
      text: `Polish Your Words. Perfect Your Message.
At PTS, we provide professional Proofreading, Editing, and Subtitling services to ensure your content is clear, compelling, and error-free. Whether it’s academic papers, business documents, or multimedia content, our expert editors refine your text for grammar, tone, and style, while our subtitling team adds accurate, well-timed captions to your videos for global accessibility. We help you communicate with clarity and confidence — across formats and languages.

From text to screen, we make every word count.
Get in touch today for high-quality, fast, and reliable service you can trust!
Get a Free Quote`,
      img: "r.png",
      reverse: false,
      special: true,
    },
    {
      title: "Language Courses",
      text: `Learn a New Language. Open a World of Possibilities.
At PTS we offer expert-designed CUSTOMISED language courses that make learning fun, practical, and effective. Whether you're starting from scratch or sharpening your skills, our interactive lessons, native-speaking instructors, and flexible schedules help you learn at your own pace. From English and Spanish to Arabic, French, Chinese, and more — we bring the world’s languages to your fingertips. Join a global community of learners and boost your career, travel with confidence, or connect with new cultures.

Start speaking a new language today — your journey begins here! Whether it’s one document or a global campaign — PTS delivers language solutions that connect cultures, not just words.
Get a Free Quote`,
      img: "cr.webp",
      reverse: true,
      special: true,
    },
  ];

  return (
    <section id="services" className="services section">
      <h2>Services</h2>

      {subsections.map((sub, index) => (
        <div
          key={index}
          className={`service-subsection ${sub.reverse ? "reverse" : ""}`}
        >
          {/* TEXT COLUMN */}
          <div className="service-text">
            {sub.special ? (
              <div className="service-text-box">
                <h3>{sub.title}</h3>
                <p className="preserve-newlines">{sub.text}</p>
                <div className="cta-row">
                  <a href="#quote" className="btn">
                    Get a Free Quote
                  </a>
                </div>
              </div>
            ) : (
              <>
                <h3>{sub.title}</h3>
                <p>{sub.text}</p>
                <a href="#quote" className="btn">
                  Get a Free Quote
                </a>
              </>
            )}
          </div>

          {/* IMAGE COLUMN */}
          <div className={`service-img ${sub.reverse ? "left" : ""}`}>
            {serviceImages[sub.img] ? (
              <img src={serviceImages[sub.img]} alt={sub.title} />
            ) : null}
          </div>
        </div>
      ))}
    </section>
  );
};

export default Services;
